import Grid from '@material-ui/core/Grid';
import * as React from 'react';
import {CONTACT_TAB, SUBAGENTS_SORT_BY, USERS_SORT_BY} from '../../../Config/appConfig';
import SortButton from '../../Custom/SortButton';

interface InvitationTableViewHeaderProps {
    currentTab: string,
    sortBy: string,
    clickSort: (sortBy: string) => void
}

class InvitationTableViewHeader extends React.Component <InvitationTableViewHeaderProps, {}> {
    public render() {
        if (this.props.currentTab === CONTACT_TAB.COMPANY) {
            return (
                <div className="cmTableViewHeader">
                    <Grid className="cmTableViewHeaderCol" item xs={8}>
                        <div className={`cmTableViewHeaderContainer${this.props.sortBy === SUBAGENTS_SORT_BY.COMPANY ? " cmTableViewHeaderContainerFocused" : ""}`}>
                            <div className="cmTableViewHeaderTitle">Sub-agent Company</div>
                            <SortButton clickSort={() => this.props.clickSort(SUBAGENTS_SORT_BY.COMPANY)} isFocused={this.props.sortBy === SUBAGENTS_SORT_BY.COMPANY}/>
                        </div>
                    </Grid>
                    <Grid className="cmTableViewHeaderCol" item xs={3}>
                        <div className={`cmTableViewHeaderContainer${this.props.sortBy === SUBAGENTS_SORT_BY.LAST_ACTIVE ? " cmTableViewHeaderContainerFocused" : ""}`}>
                            <div className="cmTableViewHeaderTitle">Relevant Date</div>
                            <SortButton clickSort={() => this.props.clickSort(SUBAGENTS_SORT_BY.LAST_ACTIVE)} isFocused={this.props.sortBy === SUBAGENTS_SORT_BY.LAST_ACTIVE}/>
                        </div>
                    </Grid>
                    <Grid className="cmTableViewHeaderCol" item xs={1}>
                        <div className="cmTableViewHeaderContainer">
                            <div className="cmTableViewHeaderTitle">Action</div>
                        </div>
                    </Grid>
                </div>
            );
        }
        else {
            const isApiUserTab = this.props.currentTab === CONTACT_TAB.API_USER;
            return (
                <div className="cmTableViewHeader">
                    <Grid className="cmTableViewHeaderCol" item xs={4}>
                        <div className={`cmTableViewHeaderContainer${this.props.sortBy === USERS_SORT_BY.NAME ? " cmTableViewHeaderContainerFocused" : ""}`}>
                            <div className="cmTableViewHeaderTitle">User</div>
                            <SortButton clickSort={() => this.props.clickSort(USERS_SORT_BY.NAME)} isFocused={this.props.sortBy === USERS_SORT_BY.NAME}/>
                        </div>
                    </Grid>
                    <Grid className="cmTableViewHeaderCol" item xs={3}>
                        <div className={`cmTableViewHeaderContainer${this.props.sortBy === USERS_SORT_BY.LAST_ACTIVE ? " cmTableViewHeaderContainerFocused" : ""}`}>
                            <div className="cmTableViewHeaderTitle">Relevant Date</div>
                            <SortButton clickSort={() => this.props.clickSort(USERS_SORT_BY.LAST_ACTIVE)} isFocused={this.props.sortBy === USERS_SORT_BY.LAST_ACTIVE}/>
                        </div>
                    </Grid>
                    <Grid className="cmTableViewHeaderCol" item xs={2}>
                        <div className={`cmTableViewHeaderContainer${this.props.sortBy === USERS_SORT_BY.ROLE ? " cmTableViewHeaderContainerFocused" : ""}`}>
                            <div className="cmTableViewHeaderTitle">Role</div>
                            <SortButton clickSort={() => this.props.clickSort(USERS_SORT_BY.ROLE)} isFocused={this.props.sortBy === USERS_SORT_BY.ROLE}/>
                        </div>
                    </Grid>
                    <Grid className="cmTableViewHeaderCol" item xs={isApiUserTab ? 3 : 2}>
                        <div className={`cmTableViewHeaderContainer${this.props.sortBy === USERS_SORT_BY.STATUS ? " cmTableViewHeaderContainerFocused" : ""}`}>
                            <div className="cmTableViewHeaderTitle">Status</div>
                            <SortButton clickSort={() => this.props.clickSort(USERS_SORT_BY.STATUS)} isFocused={this.props.sortBy === USERS_SORT_BY.STATUS}/>
                        </div>
                    </Grid>
                    {!isApiUserTab &&
                    <Grid className="cmTableViewHeaderCol" item xs={1}>
                        <div className="cmTableViewHeaderContainer">
                            <div className="cmTableViewHeaderTitle">Action</div>
                        </div>
                    </Grid>}
                </div>
            );
        }
    }

}

export default InvitationTableViewHeader;


// WEBPACK FOOTER //
// ./src/Components/Contact/Invitation/InvitationTableViewHeader.tsx